module.exports = __webpack_public_path__ + "static/media/48.55cb24fc.png";